import { Extension, wrappingInputRule } from '@tiptap/core';

export const orderedListTypeAInputRegex = /^a\.\s$/;

export const OrderedListTypeInputRule = Extension.create({
    name: 'orderedListTypeInputRule',

    addInputRules() {
        const orderedListType = this.editor.schema.nodes.orderedList;
        if (!orderedListType) return [];

        return [
            wrappingInputRule({
                find: orderedListTypeAInputRegex,
                type: orderedListType,
                getAttributes: () => ({ type: 'a' }),
                joinPredicate: (_, node) => node.attrs.type === 'a',
            }),
        ];
    },
});
